// export const SITE_URL = "http://localhost:1337";
export const SITE_URL = "https://icon-strapi.herokuapp.com";
